import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import ContentCadastro from '../layout/content/ContentCadastro'
import Table from '../layout/table/Table';
import TableTypeEnum from '../layout/table/TableTypeEnum';
import AlignEnum from '../layout/table/AlignEnum';
import InputLabel from '../layout/input/InputLabel';
import Button from '../layout/button/Button';

import PedidoService from '../../service/PedidoService';

import { moeda, formataEndereco, formatarDataTime } from '../../helper/Formatar';

import { getParam } from '../../helper/Url';

import './Pedido.css';
import { Modal } from 'react-bootstrap';

class View extends  AbstractComponent {
    constructor(state) {
        super(state);

        this.state = {
            modalErroMsg: {
                message: '',
                code: 0
            },

            pedido: {
                pedido_item: [],
                endereco_entrega: {},
                totalizador: {},
                logs: ''
            },

            head : [
                {nome: 'Qtd', campo: 'quantidade', type: TableTypeEnum.NUMBER, scale: 3, isInteger: true, align: AlignEnum.RIGHT, width: '16%'},
                {nome: 'UN', campo: 'unidade', type: TableTypeEnum.TEXT, width: '8%'},
                {nome: 'Descrição', campo: 'descricao', type: TableTypeEnum.TEXT, width: '52%'},
                {nome: 'Total', campo: 'total', type: TableTypeEnum.MOEDA, align: AlignEnum.RIGHT, width: '24%'}
            ],
            modalStatus: false,
            ListaStatusPedidos: []      
        }
    }

    getTaxaEntrega() {                
        if(this.state.pedido.totalizador.taxa_entrega === 0.00)
            return 'Grátis';

        return moeda(this.state.pedido.totalizador.taxa_entrega);
    }

    showSummary(texto, valor) {
        return (
            <div 
                className="col-md-12                                 
                            col-sm-12                                               
                            col-lg-12                                               
                            col-xs-12"
                style={{
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    marginTop: '10px'
                }}
            >
                <div 
                    className="col-md-6                                 
                                col-sm-6                                               
                                col-lg-6                                               
                                col-xs-6
                                text-font-16px"
                    style={{
                        paddingLeft: '0px'                                    
                    }}
                >
                    <b>{texto}</b>
                </div>
                
                <div 
                    className="col-md-6                                 
                                col-sm-6                                               
                                col-lg-6                                               
                                col-xs-6
                                text-right
                                text-font-16px"
                    style={{
                        paddingRight: '0px'
                    }}
                >                                
                    {valor}
                </div>
            </div>
        )
    }
    
    componentDidMount() {
        const id = getParam('id');        

        if((id === undefined)||(id === null)||(id === 0))
            return ;            

        this.setState({
            modalErroMsg: {
                message: '',
                code: 0
            },
            preload: true
        });

        PedidoService.get(id).then(resposta => {
            this.setState({
                pedido: resposta.data,
                AuxStatusPedido: resposta.data.status,
                modalErroMsg: {
                    message: '',
                    code: 0
                },
                preload: false
            });
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preload: false
            });
        });
    }   

    showPedidoCab() { 
        return (
            <Fragment>
                <InputLabel
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    value={this.state.pedido.id}
                >
                    Nº Pedido
                </InputLabel>

                <InputLabel
                    md={3} 
                    xs={12} 
                    sm={3} 
                    lg={3}
                    value={formatarDataTime(this.state.pedido.data)}
                >
                    Data
                </InputLabel>

                <InputLabel
                    md={6} 
                    xs={12} 
                    sm={6} 
                    lg={6}
                    value={this.state.pedido.destinatario}
                >
                    Cliente
                </InputLabel>
            </Fragment>
        );
    }

    aprovarPagamento() {
      const id = getParam('id');      

        if((id === undefined)||(id === null)||(id === 0))
            return ;

      PedidoService.aprovarPagamento(id).then(resposta => {
            this.setState({
              pedido: {
                ...this.state.pedido,
                status: "Pedido Realizado",
                logs: resposta.data + "\n" + this.state.pedido.logs
              },
              modalErroMsg: {
                message: '',
                code: 0
              },
              modalStatus: false
            });
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preload: false
            });
        });
    }

    render () {
        return (
            <ContentCadastro 
                className="container-pedido"
                title={"Pedido - Status: " + (this.state.pedido.status)}
                history={'pedido'}
                
                preload={this.state.preload || this.state.preload}                                
                component={this.showPedidoCab()}

                route={(route) => this.props.route(route)}
            >      
                {(this.state.pedido.status === "Aguardando Pagamento"
                  || this.state.pedido.status === "Pagamento Negado"
                  || this.state.pedido.status === "Pagamento Reprovado"
                ) && 
                    <Button 
                        className="btn btn-success"
                        type="button"
                        background={3}
                        style={{float: 'right'}}
                        onClick={() => this.setState({modalStatus: true})}                    
                    >
                        Aprovar pagamento do pedido
                    </Button>
                }
                <div className="container-overflow"> 
                    <section className="">
                        <Table
                            head={this.state.head}
                            body={this.state.pedido.pedido_item}
                            ref={ref => this.table = ref}

                            cadastro={false}                                                                                             
                        />                                                        
                    </section>

                    <div 
                        className="col-md-12                                 
                                    col-sm-12                                               
                                    col-lg-12                                               
                                    col-xs-12"
                        style={{
                            borderTop: '1px solid #e6e4e6',
                            paddingLeft: '0px',
                            paddingRight: '0px',
                            marginBottom: '10px'
                        }}
                    >
                        {this.showSummary("Subtotal", moeda(this.state.pedido.totalizador.sub_total))}                        

                        {this.showSummary("Taxa de entrega", this.getTaxaEntrega())}

                        {this.showSummary("Total", moeda(this.state.pedido.totalizador.total))}                        
                    </div>                        
                    
                    {
                        this.state.pedido.endereco_entrega.cep &&                        
                        <div 
                            className="col-md-12                                 
                                        col-sm-12                                               
                                        col-lg-12                                               
                                        col-xs-12"
                            style={{
                                borderTop: '1px solid #e6e4e6',
                                paddingLeft: '0px',
                                paddingRight: '0px',
                                marginBottom: '10px'
                            }}
                        >
                            <div 
                                className="col-md-12                                 
                                            col-sm-12                                               
                                            col-lg-12                                               
                                            col-xs-12
                                            text-font-16px"
                                style={{         
                                    paddingLeft: '0px',
                                    paddingRight: '0px',                           
                                    marginTop: '10px'                                    
                                }}
                            >
                                <b>Endereço de entrega</b>
                            </div>

                            <div 
                                className="col-md-12                                 
                                            col-sm-12                                               
                                            col-lg-12                                               
                                            col-xs-12
                                            text-font-14px"
                                style={{
                                    paddingLeft: '0px',
                                    paddingRight: '0px',                                                                        
                                }}
                            >                                 
                                {this.state.pedido.endereco_entrega.cep + ' - ' + formataEndereco(this.state.pedido.endereco_entrega.logradouro, this.state.pedido.endereco_entrega.endereco, true) + ', ' + this.state.pedido.endereco_entrega.numero}                            
                            </div> 

                            <div 
                                className="col-md-12                                 
                                            col-sm-12                                               
                                            col-lg-12                                               
                                            col-xs-12
                                            text-font-14px"
                                style={{
                                    paddingLeft: '0px',
                                    paddingRight: '0px',                                                                        
                                }}
                            >                                                             
                                {this.state.pedido.endereco_entrega.bairro + ' - ' + this.state.pedido.endereco_entrega.cidade + ' ' + this.state.pedido.endereco_entrega.uf}
                            </div> 
                        </div>  
                    }                     

                    {
                        this.state.pedido.observacao &&                        
                        <div 
                            className="col-md-12                                 
                                        col-sm-12                                               
                                        col-lg-12                                               
                                        col-xs-12"
                            style={{
                                borderTop: '1px solid #e6e4e6',
                                paddingLeft: '0px',
                                paddingRight: '0px',
                                marginBottom: '10px'
                            }}
                        >
                            <div 
                                className="col-md-12                                 
                                            col-sm-12                                               
                                            col-lg-12                                               
                                            col-xs-12
                                            text-font-16px"
                                style={{         
                                    paddingLeft: '0px',
                                    paddingRight: '0px',                           
                                    marginTop: '10px'                                    
                                }}
                            >
                                <b>Observação</b>
                            </div>

                            <div 
                                className="col-md-12                                 
                                            col-sm-12                                               
                                            col-lg-12                                               
                                            col-xs-12
                                            text-font-14px"
                                style={{
                                    paddingLeft: '0px',
                                    paddingRight: '0px',                                                                        
                                }}
                            >                                 
                                <textarea
                                    style={{
                                        height: "100px",
                                        minHeight: "100px",
                                    }}
                                    spellCheck="false"
                                    className="form-control textArea"
                                    value={this.state.pedido.observacao}
                                    disabled
                                />                                    
                            </div>                             
                        </div>                                               
                    }
                
                    <div 
                        className="col-md-12                                 
                                    col-sm-12                                               
                                    col-lg-12                                               
                                    col-xs-12"
                        style={{
                            borderTop: '1px solid #e6e4e6',
                            paddingLeft: '0px',
                            paddingRight: '0px',
                            marginBottom: '10px'
                        }}
                    >
                        <div 
                            className="col-md-12                                 
                                        col-sm-12                                               
                                        col-lg-12                                               
                                        col-xs-12
                                        text-font-16px"
                            style={{         
                                paddingLeft: '0px',
                                paddingRight: '0px',                           
                                marginTop: '10px'                                    
                            }}
                        >
                            <b>Logs do pedido</b>
                        </div>

                        <div 
                            className="col-md-12                                 
                                        col-sm-12                                               
                                        col-lg-12                                               
                                        col-xs-12
                                        text-font-14px"
                            style={{
                                paddingLeft: '0px',
                                paddingRight: '0px',                                                                        
                            }}
                        >                                 
                            <textarea
                                style={{
                                    height: "100px",
                                    minHeight: "100px",
                                }}
                                spellCheck="false"
                                className="form-control textArea"
                                value={
                                  this.state.pedido.logs !== '' 
                                  ? this.state.pedido.logs
                                  : "Neste momento não foi registrado nenhum log para o pedido."
                                }
                                disabled
                            />                                    
                        </div>                             
                    </div>                                               
                </div>
                <Modal 
                  style={{zIndex: 9999}}
                  show={this.state.modalStatus}
                  onHide={() => this.setState({ 
                    modalStatus: false
                  })}
                >
                  <Modal.Header closeButton>
                    <h4>
                      &nbsp;
                      Deseja aprovar o pagamento deste pedido?
                    </h4>
                  </Modal.Header>
                  <Modal.Body >
                    <h4>
                      O status do pedido será alterado para --Pedido Realizado--
                    </h4>
                   </Modal.Body>
                   <Modal.Footer>
                    <Button
                      className="btn btn-danger"
                      type="button"
                      background={3}
                      style={{float: 'left'}}
                      onClick={() => this.setState({ 
                        modalStatus: false
                      })}                    
                    >
                        Cancelar
                    </Button>
                    <Button 
                      className="btn btn-success"
                      type="button"
                      background={3}
                      style={{float: 'right'}}
                      onClick={() => this.aprovarPagamento()}                    
                    >
                        Aplicar
                    </Button>
                   </Modal.Footer>
                </Modal>
            </ContentCadastro>
        )   
    }
}

export default View;
